import React from 'react';
import { Button, message } from 'antd';
import Files from 'react-files';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { observer } from 'mobx-react';
import { checkTemplateHeaderFileSize } from '../../../../../../TemplateMessages/helpers';
import styles from './FileUploadButton.module.scss';
const FileUploadButton = ({ blockField, handleSetHeader, richTemplateHeader, className, accepts, buttonText }) => {
    const onFileChange = (files) => {
        if (!files || files.length === 0)
            return;
        const file = files[0];
        const sizeError = checkTemplateHeaderFileSize(file);
        if (sizeError) {
            message.error(React.createElement(Trans, { i18nKey: sizeError.key, values: { size: sizeError.size } }));
            return;
        }
        handleSetHeader(files);
    };
    return (React.createElement("div", { className: classnames(styles.buttonWrapper, className) },
        React.createElement(Files, { multiple: false, onChange: !blockField ? onFileChange : null, accepts: accepts, onError: null, clickable: true },
            React.createElement(Button, { className: classnames(styles.button), type: "primary" }, (richTemplateHeader === null || richTemplateHeader === void 0 ? void 0 : richTemplateHeader.name) || React.createElement(Trans, { i18nKey: buttonText })))));
};
export default observer(FileUploadButton);
